import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/**
 * Order matters here. We want all auth/* routes to take precedence over path: '', because
 * the DashboardModule handles incorrect routes by using a path: '**' statement.
 * If the AuthModule is not loaded first, then the path: '**' will capture all auth routes as invalid.
 */
const routes: Routes = [
  {
    path: '',
    redirectTo: 'metrics',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./views/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: '',
    loadChildren: () => import('./views/dashboard/dashboard.module').then(m => m.DashboardModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
